<template>
  <div id="bottomRight">
    <el-dialog title="重点航班历史" :visible.sync="dialogFormVisible" width="30%">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column v-for="(item,index) in data" :key="index" :prop="item['prop']" :label="item['label']" :width="item['width']">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <div @click="checkHistory">
      <div class="index-bottom-3-bottom-top">航班客座率情况</div>
      <dv-scroll-board :config="config" style="width:7rem;height:3rem;" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
    
      dialogFormVisible: false,
      tableData: [],
      data:[
        {prop: 'today_time',label: '时间',width: '150'},
        {prop: '出港航班',label: '出港航班'},
        {prop: '旅客人数',label: '旅客人数'},
        {prop: '客座率',label: '客座率'},
      ],
      config: {
        header: ['出港航班', '旅客人数', '客座率'],
        data: [],
        headerBGC: '#0d1120',
        oddRowBGC: '#0d1120',
        evenRowBGC: '#0d1120',
        // index: true,
        // columnWidth: [50],
        // align: ['center']
      }
    };
  },
  mounted() {
    this.draw();
  },
  created() {
    setTimeout(() => {
      this.getData(this.$store.state['flightList'])
    }, 300)
  },
  computed: {
    listData() {
      return this.$store.state['flightList']
    }
  },
  watch: {
    listData(data) {
      this.getData(data)
    }
  },
  methods: {
    checkHistory(){
      axios({
        url: `http://115.190.8.169:5000/get_flight_data`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.tableData = res.data
        }
      })
      this.dialogFormVisible = true
    },
    getData(data) {
      this.config.data = []
      data.forEach(item => {
        this.config.data.push([item['出港航班'],`<span style="background: blue;padding: 5px 15px;">${item['旅客人数']}</span>`,`<span style="background: blue;padding: 5px 15px;">${(parseFloat(item['客座率']) *100).toFixed(2)}%</span>`])
      })
      this.config = { ...this.config };
    },
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style lang="scss">
.index-bottom-3-bottom-top {
  margin: 0 auto;
  margin-bottom: .3rem;
  width: 4rem;
  margin-left: 1rem;
  padding: 15px 0;
  color: #999;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  border: 1px solid #999;

  .index-bottom-3-bottom-top-bottom {
    display: flex;
    justify-content: center;
  }
}

#bottomRight {
  // margin-left: 1rem;
  margin-top: -0.3rem;
  padding: 0.35rem 0.1rem;
  height: 5.5rem;
  min-width: 2.75rem;
  border-radius: 0.0625rem;

  .bg-color-black {
    height: 4.3125rem;
    min-width: 18.08rem;
    border-radius: 0.125rem;

    .d-flex-right {
      padding: 0.3rem 0.1rem;
      display: flex;
      align-items: center;

      .d-flex-right-li-text {
        margin-top: 0.1rem;
        width: 100%;
        line-height: 0.4rem;
        text-align: center;
        border: 1px solid #999;
        font-size: 14px;
      }
    }
  }

  .text {
    color: #c3cbde;
    font-size: 0.18rem;
  }

  //下滑线动态
  .decoration2 {
    position: absolute;
    right: 0.125rem;
  }

  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;

    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>